<div style="display: flex;
min-height: 100vh;
flex-direction: column;
justify-content: space-between;">
    <router-outlet style="display: contents;"></router-outlet>
    <app-footer style="display: contents;"></app-footer>
</div>